import React from 'react';

const MarsIcon: React.FC<{ className?: string }> = (props) => (
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M 400.055 127 C 400.055 128.657 398.712 130 397.055 130 L 363.055 130 C 361.398 130 360.055 128.657 360.055 127 L 360.055 68.284 L 252.263 176.076 C 269.493 198.955 280 227.658 280 260 C 280 310.017 253.316 356.235 210 381.244 C 116.667 435.13 0 367.772 0 260 C 0 209.983 26.684 163.765 70 138.756 C 122.15 108.647 181.585 116.391 223.883 147.888 L 331.771 40 L 273.055 40 C 271.398 40 270.055 38.657 270.055 37 L 270.055 3 C 270.055 1.343 271.398 0 273.055 0 L 397.055 0 C 398.712 0 400.055 1.343 400.055 3 Z M 90 346.603 C 156.667 385.093 240 336.98 240 260 C 240 224.273 220.94 191.261 190 173.397 C 123.333 134.907 40 183.02 40 260 C 40 295.727 59.06 328.739 90 346.603 Z"
      fill="currentColor"
    />
  </svg>
);
export default MarsIcon;
